import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
// globals
import { SLA_AIRPORT_BOOKINGTYPE_MAPPING, SLA_TERMINALS_BOOKINGTYPE_MAPPING } from 'src/globals';

let default_pricing = {
    zonePrice: null,
    bagVolumeLimit: null,
    bagsIncluded: null,
    pricePerAdditionalBag: null,
    pricePerAdditionalBagAboveVolumeLimit: null,
    disabled: true,
};

interface SlaPricingState {
    airportZonePricing: any;
    clone_airportZonePricing: any;
    original_airportZonePricing: any;
    isPriceEdited: boolean;
    airportZoneRules: any;
    clone_airportZoneRules: any;
    original_airportZoneRules: any;
    isRuleEdited: boolean;

    hasFiltersApplied: boolean;
    airportCity: string;
    bookingType: 'ABC' | 'CarouselCollection' | '';
    terminal: string;
}

const initialState: SlaPricingState = {
    airportZonePricing: null,
    original_airportZonePricing: null,
    clone_airportZonePricing: null,
    isPriceEdited: false,
    airportZoneRules: null,
    clone_airportZoneRules: null,
    original_airportZoneRules: null,
    isRuleEdited: false,

    hasFiltersApplied: false,
    airportCity: '',
    bookingType: '',
    terminal: '',
};

export const slaPricingSlice = createSlice({
    name: 'slaPricing',
    initialState,
    reducers: {
        setPricingResponse: (state, action: PayloadAction<any>) => {
            state.airportZonePricing = action.payload;

            let clone = action.payload.map((airport) => {
                // let typeToAdd = null;
                let timeSlotType = airport.pricings.map((price) => price.timeSlotType);

                // if (timeSlotType.length < 2) {
                //     if (timeSlotType[0] === 'Premium') {
                //         typeToAdd = 'Value';
                //     } else {
                //         typeToAdd = 'Premium';
                //     }
                // }

                let pricings = airport.pricings.map((price) => {
                    let priceComparison = {};

                    Object.keys(price).forEach((key) => {
                        priceComparison[key] = price[key];
                    });

                    return {
                        ...priceComparison,
                    };
                });

                if (!timeSlotType.includes('Premium')) {
                    pricings.push({
                        ...default_pricing,
                        timeSlotType: 'Premium',
                    });
                }
                if (!timeSlotType.includes('Value')) {
                    pricings.push({
                        ...default_pricing,
                        timeSlotType: 'Value',
                    });
                }
                if (!timeSlotType.includes('SuperSaver')) {
                    pricings.push({
                        ...default_pricing,
                        timeSlotType: 'SuperSaver',
                    });
                }
                if (!timeSlotType.includes('Daylong')) {
                    pricings.push({
                        ...default_pricing,
                        timeSlotType: 'Daylong',
                    });
                }

                // if (typeToAdd) {
                //     pricings.push({
                //         ...default_pricing,
                //         timeSlotType: typeToAdd,
                //     });
                // }

                return {
                    ...airport,
                    pricings,
                };
            });

            state.isPriceEdited = false;
            state.clone_airportZonePricing = clone;
            state.original_airportZonePricing = clone;
        },
        setPricingCellValue: (state, action: PayloadAction<any>) => {
            const { type, name, index, value } = action.payload;
            let data = [...current(state).clone_airportZonePricing];

            let updated_data = data.map((airport, id) => {
                if (id === index) {
                    let zonePricing = airport.pricings.map((price) => {
                        if (price.timeSlotType === type) {
                            return {
                                ...price,
                                [name]: value,
                            };
                        } else {
                            return {
                                ...price,
                            };
                        }
                    });

                    return {
                        ...airport,
                        pricings: zonePricing,
                        isEdited: true,
                    };
                } else {
                    return {
                        ...airport,
                    };
                }
            });

            state.isPriceEdited = true;
            state.clone_airportZonePricing = updated_data;
        },

        setRulesResponse: (state, action: PayloadAction<any>) => {
            state.airportZoneRules = action.payload;

            let cloneRules = action.payload.map((rule) => {
                let zoneRules = {};

                Object.keys(rule).forEach((key) => {
                    if (key !== 'zoneId' && key !== 'zoneName' && key !== 'zoneDescription') {
                        zoneRules[key] = rule[key];
                    }
                });

                return {
                    ...rule,
                    ...zoneRules,
                };
            });

            state.isRuleEdited = false;
            state.clone_airportZoneRules = cloneRules;
            state.original_airportZoneRules = cloneRules;
        },

        setSlaCellValue: (state, action: PayloadAction<any>) => {
            const { name, index, value, type } = action.payload;
            let data = [...current(state).clone_airportZoneRules];

            let updated_data = data.map((rule, id) => {
                if (id === index) {
                    // for array type values
                    if (type) {
                        let newValue = value ? [...rule[name], type] : rule[name].filter((item) => item !== type);

                        return {
                            ...rule,
                            [name]: newValue,
                        };
                    } else {
                        //  for strig & boolean values
                        return {
                            ...rule,
                            [name]: value,
                        };
                    }
                } else {
                    return {
                        ...rule,
                    };
                }
            });

            state.isRuleEdited = true;
            state.clone_airportZoneRules = updated_data;
        },

        resetData: (state, action: PayloadAction<any>) => {
            state.isPriceEdited = action.payload;
            state.isRuleEdited = action.payload;

            state.clone_airportZoneRules = state.original_airportZoneRules;
            state.clone_airportZonePricing = state.original_airportZonePricing;
        },

        setAirport: (state, action: PayloadAction<any>) => {
            const value = action.payload;

            state.airportCity = value;
            state.bookingType = SLA_AIRPORT_BOOKINGTYPE_MAPPING[value][0].value;
            state.terminal = SLA_TERMINALS_BOOKINGTYPE_MAPPING[value][0].value;
        },
        setBookingType: (state, action: PayloadAction<any>) => {
            state.bookingType = action.payload;
        },
        setTerminal: (state, action: PayloadAction<any>) => {
            state.terminal = action.payload;
        },
        applyFilters: (state) => {
            state.hasFiltersApplied = true;
        },
        clearFilters: (state, action: PayloadAction<any>) => {
            state.hasFiltersApplied = false;

            state.airportCity = action.payload.airportCity;
            state.bookingType = action.payload.bookingType;
            state.terminal = action.payload.terminal;
        },
    },
});

export const {
    setPricingResponse,
    setPricingCellValue,
    setRulesResponse,
    setSlaCellValue,
    resetData,
    setAirport,
    setBookingType,
    setTerminal,
    applyFilters,
    clearFilters,
} = slaPricingSlice.actions;

export default slaPricingSlice.reducer;
